module.exports = __webpack_public_path__ + "img/playBtn.00e1da8f.png";